module.exports = __webpack_public_path__ + "static/media/whitelogo.06be4581.png";